import { PropsWithChildren } from 'react';

import { Slider, SliderProvider } from '@shared/v2/components/Slider';

import {
  Container,
  Indicator,
  LeftButton,
  RightButton,
  Wrapper,
} from '@/v2/components/ui/Slider';

const PackageOptionSlider = ({
  children,
  initialKey,
}: PropsWithChildren<{ initialKey?: string }>) => (
  <SliderProvider initialKey={initialKey}>
    <Slider
      Indicator={Indicator}
      LeftButton={LeftButton}
      RightButton={RightButton}
      Container={Container}
      Wrapper={Wrapper}
    >
      {children}
    </Slider>
  </SliderProvider>
);

export default PackageOptionSlider;
